import { LoadingButton } from '@mui/lab';
import { Stack } from '@mui/material';
import { Iconify } from 'src/components/iconify';
import { useLocales } from 'src/locales';
import type { DirectMessageControl } from './useDirectMessageControl';

export const UserProfileShortActions = ({
  dmControl,
}: {
  dmControl: DirectMessageControl;
}) => {
  const { translate } = useLocales();
  const { handleGoToChat, dmChannelStatus, chatLoading } = dmControl;

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <LoadingButton
        loading={!!chatLoading}
        variant="outlined"
        color="inherit"
        size="small"
        onClick={handleGoToChat}
        startIcon={<Iconify icon="tabler:messages" />}
      >
        {
          {
            new: translate('communicate.create_modal.start_dm'),
            open: translate('communicate.create_modal.open_dm'),
            reopen: translate('communicate.create_modal.direct_reopen_dm'),
          }[dmChannelStatus]
        }
      </LoadingButton>
    </Stack>
  );
};
